import { render } from "./floating-toast.vue?vue&type=template&id=4569570e"
import script from "./floating-toast.vue?vue&type=script&lang=js"
export * from "./floating-toast.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__